export enum VIEW_MODES {
  MANUAL_ACCEPTANCE,
  CALENDAR,
  BENEFITS_MANAGER,
  PERMISSION_MANAGER,
  HOLIDAYS,
  EXCLUDE,
  TIMESHEET_IMPORT,
}
